import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Zone } from "../../../domain/entities/user";
import { type UsersDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listZones = createAsyncThunk<
  Zone[],
  void,
  { dispatch: UsersDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_ZONES, async (_, { extra }) => {
  return await extra.usersRepo.listZones();
});
